/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SuppliersRoutingModule
 * Purpose		: Routing module for Suppliers.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SuppliersListComponent } from './SuppliersList.component';
import { SuppliersAddComponent }  from './SuppliersAdd.component';
import { SuppliersEditComponent } from './SuppliersEdit.component';
import { SuppliersDetailsComponent } from './SuppliersDetails.component';

const SuppliersRoutes: Routes = [
	{ path: 'Suppliers',  component: SuppliersListComponent },
	{ path: 'Suppliers/add', component: SuppliersAddComponent },
	{ path: 'Suppliers/:id', component: SuppliersEditComponent },
	{ path: 'Suppliers/Details/:id', component: SuppliersDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(SuppliersRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class SuppliersRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Suppliers/Suppliers-routing.module.ts